import apiReq from '../commontools/api.js'
export function GetBranchValid(){
	var url='/Branch/GetBranchValid';
	return apiReq.get(url);
}
export function GetAllBranch(){
	var url='/Branch/GetAllBranch';
	return apiReq.get(url);
}
export function GetBranchByCorpID(corpid){
	var url='/Branch/GetBranchByCorpID/'+corpid;
	return apiReq.get(url);
}
export function GetBranchByOrderID(orderid){
	var url='/Branch/GetBranchByOrderID/'+orderid;
	return apiReq.get(url);
}

export function GetBranchByID(branchid){
	var url='/Branch/GetBranchByID/'+branchid;
	return apiReq.get(url);
}
export function AddBranch(info){
	var url='/Branch/AddBranch';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function EditBranch(info){
	var url='/Branch/EditBranch';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function UploadBranchImg(info,branchid){
	var url='/ShowFile/UploadBranchImg/'+branchid;
	return apiReq.post(url,info);
}
export default{
	GetBranchValid,
	GetAllBranch,
	AddBranch,
	EditBranch,
	GetBranchByID,
	UploadBranchImg,
	GetBranchByCorpID,
	GetBranchByOrderID
}